import { SquareArrowOutUpRight } from 'lucide-react';

import { ProfileImage } from '@/shared/components/profile-image';
import { formatNumber } from '@/shared/utils/format-number';

interface ProfilePopupProps {
  profileImageUrl: string;
  username: string;
  nickname?: string;
  followerCount: number;
  profileUrl: string;
  onClose: () => void;
}

export function ProfilePopup({
  profileImageUrl,
  username,
  nickname,
  followerCount,
  profileUrl,
  onClose,
}: ProfilePopupProps) {
  const handleExternalLinkClick = () => {
    window.open(profileUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };

  const displayName = username;

  return (
    <div className="relative w-full rounded-lg bg-white shadow-lg">
      <div className="flex flex-col gap-3 p-4">
        <ProfileImage
          src={profileImageUrl}
          name={displayName}
          className="size-10 shrink-0 rounded-full object-cover"
        />

        <div className="flex flex-col gap-1">
          <div className="text-foreground text-base leading-none font-semibold">{displayName}</div>
          {nickname && (
            <div className="text-muted-foreground text-sm leading-none font-normal">{nickname}</div>
          )}
        </div>

        <div className="flex flex-row items-center gap-3">
          <div className="flex flex-row items-center gap-1">
            <div className="text-foreground text-base leading-none font-semibold">
              {formatNumber(followerCount)}
            </div>
            <div className="text-muted-foreground text-sm leading-none font-normal">Followers</div>
          </div>
        </div>
      </div>

      <button
        onClick={handleExternalLinkClick}
        className="absolute top-4 right-4 size-4 transition-opacity hover:opacity-70"
        aria-label="Open profile in new tab"
      >
        <SquareArrowOutUpRight className="size-full" />
      </button>
    </div>
  );
}
